import { render, staticRenderFns } from "./appendixInput.vue?vue&type=template&id=4c5bc16d&scoped=true&"
import script from "./appendixInput.vue?vue&type=script&lang=ts&"
export * from "./appendixInput.vue?vue&type=script&lang=ts&"
import style0 from "./appendixInput.vue?vue&type=style&index=0&id=4c5bc16d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bc16d",
  null
  
)

export default component.exports